import type { UseSortByProps } from 'react-instantsearch';
import { useSortBy } from 'react-instantsearch';

export function VirtualSortBy(props: UseSortByProps) {
  useSortBy(props);

  return null;
}
